import React from 'react';
import { Card, Divider } from 'antd';
import { buildOptions } from './../../utils/survey';
import Flexbox from 'flexbox-react';
import { VictoryChart, VictoryAxis, VictoryTheme, VictoryLine } from 'victory';
import { injectIntl } from 'react-intl';
import messages from './messages';
import ResultTotalAnswers from '../ResultTotalAnswers';
import ResultTitle from '../ResultTitle';

const getChartData = (options) => {
	let optionsChart = [];
	for (let i = 0; i <= options.length; i++) {
		if (typeof options[i] === 'undefined') {
			optionsChart.push({ x: i, y: 0 });
		} else {
			optionsChart.push({ x: i, y: options[i] });
		}
	}
	return optionsChart;
};

const ResultAge = ({ id, stepAnswers, questions, intl: { formatMessage } }) => {
	const answerValues = Object.values(stepAnswers);
	const options = buildOptions(answerValues);
	return (
		<Card className='Result'>
			<div className='Answer'>
				<ResultTitle questions={questions} id={id}/>
				<ResultTotalAnswers stepAnswers={stepAnswers}/>
			</div>
			<Divider/>
			<Flexbox className='Answer' style={{ width: '100%', maxWidth: 500, margin: '0 auto' }}>
				<VictoryChart theme={VictoryTheme.material} width={450}>
					<VictoryLine style={{ data: { stroke: '#18a5cf', strokeWidth: 2 } }} data={getChartData(options)}/>
					<VictoryAxis
						label={formatMessage(messages.axisYLabel)}
						style={{
							axisLabel: { fontSize: 14, padding: 35 },
							grid: { stroke: 'none' },
							ticks: { stroke: 'grey', size: 5 },
							tickLabels: { fontSize: 12, padding: 5 }
						}}
					/>
					<VictoryAxis
						dependentAxis
						label={formatMessage(messages.axisXLabel)}
						style={{
							axisLabel: { fontSize: 14, padding: 35 },
							grid: { stroke: 'none' },
							ticks: { stroke: 'grey', size: 5 },
							tickLabels: { fontSize: 12, padding: 5 }
						}}
					/>
				</VictoryChart>
			</Flexbox>
		</Card>
	
	);
};

export default injectIntl(ResultAge);






// WEBPACK FOOTER //
// ./src/components/ResultAge/ResultAge.js